
<template>
  <el-container>
    <el-header>
			<Header></Header>
		</el-header>
    <el-main>
      <div class="content-box">
        <div class="user-container">
          <div class="nav-box">
            <ul>
              <template v-for="(item, index) in navs">
                <li
                  :class="curComponent == item.key ? 'active' : ''"
                  :key="`${index}_${item.key}`"
                  @click="changeComponent(item)"
                >
                  {{ item.name }}
                </li>
              </template>
            </ul>
          </div>
          <div class="main-box">
            <div>
              <component v-bind:is="curComponent" ref="curComponent"></component>
            </div>
          </div>
        </div>
      </div>
      <span @click="go2top" v-if="showTop" class="top"><i class="el-icon-arrow-up"></i></span>
		</el-main>
  </el-container>
</template>

<script>
const components = {}
const files = require.context('./components', false, /\.vue$/)
files.keys().reduce((component, componentPath) => {
  const componentName = componentPath.split('./')[1].replace(/\.vue/, '')
  const componentContent = files(componentPath).default
  component[componentName] = componentContent
  return component
}, components)
import Header from '@/components/Header';
import { getExplanatoryType, removeExplanatoryType } from '@/utils/auth.js';
export default {
  name: 'Profile',
  components:{
    Header,
    ...components
  },
  data() {
    return {
      curNav: '隐私政策',
      showTop: false,
      curComponent: getExplanatoryType() || 'PrivacyPolicy',
      navs: [
        {
          name: '隐私政策',
          key: 'PrivacyPolicy'
        },
        {
          name: '用户声明',
          key: 'UserStatement'
        },
        {
          name: '联系我们',
          key: 'ContactUs'
        }
      ]
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.isShowTop();
    })
  },
  destroyed() {
    removeExplanatoryType();
  },
  methods: {
    changeComponent(item) {
      const { key, name } = item
      this.curComponent = key
      this.curNav = name
    },
    isShowTop(){
      if(this.$refs.curComponent.$el.offsetHeight > this.$refs.curComponent.$el.parentElement.offsetHeight){
        this.showTop = true
      } else {
        this.showTop = false
      }
    },
    go2top(){
      this.$refs.curComponent.$el.parentElement.scrollTop = 0;
    }
  },
  watch:{
    'curComponent'(){
      this.$nextTick(() => {
        this.isShowTop()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top{
  position: absolute;
  right: 30px;
  bottom: 28px;
  border: solid thin #eaeaea;
  border-radius: 50%;
  width: 46px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  i{
    color: #4f4f4f;
  }
  &:hover{
    border-color: #514DEF;
    i{
      color: #514DEF;
    }
  }
}
.user-container {
  // width: 978px;
  width: 1160px;
  margin: 0 auto;
  display: flex;
  .nav-box {
    width: 200px;
    margin-right: 126px;
    ul {
      li {
        height: 34px;
        line-height: 34px;
        margin: 9px 0;
        border-radius: 2px;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        font-size: 14px;
        &.active {
          background: #514def1a;
          color: #514def;
        }
      }
    }
  }
  .main-box {
    width: calc(100% - 312px);
    height: calc(100vh - 100px);
    overflow: hidden;
    // overflow-y: auto;
    &>div{
      width: calc(100% + 6px);
      height: 100%;
      overflow-y: scroll;
    }
  }
}
@media only screen and (max-width: 1366px) {
  .user-container {
  // width: 72%;
  width: 85%;
  margin: 0 auto;
  .nav-box {
    width: 200px;
    margin-right: 88px;
  }
  .main-box {
    width: calc(100% - 288px);
  }
}
}
</style>
